// Block dependencies
const { registerBlockType } = wp.blocks;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

import Edit from './edit';

// Register block
export default registerBlockType('flexible-faqs/accordion-expand-faqs', {
	title: __('Accordion Style Expandable FAQs', 'flexible-faqs'),
	description: __('Output one or more accordion style FAQs', 'flexible-faqs'),
	category: 'flexible-faqs',
	icon: 'editor-help', //can import custom svg icons too e.g. blockIcon,
	keywords: [
		__('Accordion', 'flexible-faqs'),
		__('Expand', 'flexible-faqs'),
		__('FAQs', 'flexible-faqs'),
	],
	supports: {
		align: false,
		customClassName: false,
	},
	edit: Edit,
	save() {
		// Rendering via PHP on the frontend
		return null;
	},
});
